/* Bare Babe · Inserts landing page kit
   Event-delegated so it survives Theme Editor section re-renders. */
(function () {
  'use strict';

  // This file is requested by more than one bb-ins-* section. Run once.
  if (window.__bbiKitLoaded) return;
  window.__bbiKitLoaded = true;

  /* ---------- logo marquee ----------
     Clones the seed group until the track is at least twice as wide as the
     visible bar, so the -50% CSS loop never runs out of logos and never
     leaves dead space — at any viewport width, with any number of logos.
     Duration scales with the number of copies, so the logos travel at the
     same speed on a phone and on an ultrawide monitor. */
  var marqueeSeeds = new WeakMap();

  function fillMarquee(scope) {
    (scope || document).querySelectorAll('[data-bbi-marquee]').forEach(function (view) {
      var track = view.querySelector('[data-bbi-marquee-track]');
      if (!track) return;

      var seed = marqueeSeeds.get(track);
      if (!seed) {
        var original = track.querySelector('[data-bbi-marquee-group]');
        if (!original) return;
        seed = original.cloneNode(true);
        marqueeSeeds.set(track, seed);
      }

      track.textContent = '';
      var first = seed.cloneNode(true);
      track.appendChild(first);

      var groupWidth = first.getBoundingClientRect().width;
      var viewWidth = view.getBoundingClientRect().width;
      if (!groupWidth || !viewWidth) return;

      var copies = Math.max(1, Math.ceil(viewWidth / groupWidth) + 1);
      var frag = document.createDocumentFragment();
      for (var i = 1; i < copies * 2; i++) {
        var clone = seed.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        frag.appendChild(clone);
      }
      track.appendChild(frag);

      var base = parseFloat(getComputedStyle(view).getPropertyValue('--bbi-speed')) || 32;
      track.style.animationDuration = (base * copies) + 's';
    });
  }

  var marqueeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(function () { fillMarquee(); }, 180);
  });

  /* ---------- before / after reveal ----------
     Three ways in: drag (pointer, so mouse + touch + pen), hover-follow on
     devices with a real cursor, and the range input for arrow keys and screen
     readers. All three write the same --bbi-ba-pos, so they stay in sync. */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setReveal(root, pct) {
    var clamped = Math.max(0, Math.min(100, pct));
    root.style.setProperty('--bbi-ba-pos', clamped + '%');
    var range = root.querySelector('[data-bbi-ba-range]');
    if (range && Number(range.value) !== Math.round(clamped)) range.value = Math.round(clamped);
  }

  function revealFromPointer(root, clientX) {
    var box = root.getBoundingClientRect();
    if (!box.width) return;
    setReveal(root, ((clientX - box.left) / box.width) * 100);
  }

  function beforeAfterDown(e) {
    var root = e.target.closest('[data-bbi-ba]');
    if (!root) return;
    root.classList.add('is-dragging');
    root.__bbiDragging = true;
    if (root.setPointerCapture && e.pointerId !== undefined) {
      try { root.setPointerCapture(e.pointerId); } catch (err) { /* not capturable */ }
    }
    // Hand focus to the range so arrow keys carry on from wherever she dragged to.
    var range = root.querySelector('[data-bbi-ba-range]');
    if (range && range.focus) {
      try { range.focus({ preventScroll: true }); } catch (err) { range.focus(); }
    }
    revealFromPointer(root, e.clientX);
  }

  function beforeAfterMove(e) {
    var root = e.target.closest('[data-bbi-ba]');
    if (!root) return;
    // Dragging always wins. Hover-follow only on a real cursor, and only
    // when the section is set to follow.
    if (!root.__bbiDragging) {
      if (!canHover) return;
      if (root.getAttribute('data-bbi-ba-follow') !== 'true') return;
      if (e.pointerType && e.pointerType !== 'mouse') return;
    } else if (e.cancelable) {
      e.preventDefault();
    }
    revealFromPointer(root, e.clientX);
  }

  function beforeAfterUp(e) {
    var root = e.target.closest('[data-bbi-ba]');
    if (!root || !root.__bbiDragging) return;
    root.__bbiDragging = false;
    root.classList.remove('is-dragging');
  }

  function beforeAfterInput(e) {
    var range = e.target.closest('[data-bbi-ba-range]');
    if (!range) return;
    var root = range.closest('[data-bbi-ba]');
    if (root) root.style.setProperty('--bbi-ba-pos', range.value + '%');
  }

  /* ---------- gallery ---------- */
  function galleryClick(e) {
    var btn = e.target.closest('.bbi-gal__thumbs button');
    if (!btn) return;
    var root = btn.closest('.bbi-gal');
    if (!root) return;
    var main = root.querySelector('.bbi-gal__main img');
    if (main && btn.dataset.src) {
      main.src = btn.dataset.src;
      if (btn.dataset.srcset) main.srcset = btn.dataset.srcset;
      else main.removeAttribute('srcset');
      if (btn.dataset.alt !== undefined) main.alt = btn.dataset.alt;
    }
    root.querySelectorAll('.bbi-gal__thumbs button').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    // keep the chosen thumbnail in view inside the strip
    if (btn.scrollIntoView) {
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  }

  /* ---------- main image prev / next ---------- */
  function galleryNav(e) {
    var prev = e.target.closest('[data-bbi-gal-prev]');
    var next = e.target.closest('[data-bbi-gal-next]');
    if (!prev && !next) return;
    var root = (prev || next).closest('.bbi-gal');
    if (!root) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.bbi-gal__thumbs button'));
    if (thumbs.length < 2) return;
    var current = thumbs.findIndex(function (b) { return b.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var target = thumbs[(current + (next ? 1 : -1) + thumbs.length) % thumbs.length];
    target.click();
  }

  // Hide the main-image arrows when there is only one image.
  function syncGalleryNav(root) {
    (root || document).querySelectorAll('.bbi-gal').forEach(function (gal) {
      var count = gal.querySelectorAll('.bbi-gal__thumbs button').length;
      gal.querySelectorAll('.bbi-gal__nav').forEach(function (btn) {
        btn.hidden = count < 2;
      });
    });
  }

  /* ---------- variant selection ---------- */
  function currentOptions(form) {
    return Array.from(form.querySelectorAll('.bbi-opt')).map(function (row) {
      var checked = row.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function updateVariant(form) {
    var dataEl = form.querySelector('[data-bbi-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var chosen = currentOptions(form);

    var match = variants.find(function (v) {
      return chosen.every(function (opt, i) { return opt === null || v.options[i] === opt; });
    });

    // reflect chosen values in the labels
    form.querySelectorAll('.bbi-opt').forEach(function (row) {
      var checked = row.querySelector('input:checked');
      var out = row.querySelector('[data-bbi-optvalue]');
      if (checked && out) out.textContent = checked.value;
    });

    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('.bbi-atc');
    var priceNow = form.closest('.bbi-buy').querySelector('[data-bbi-price-now]');
    var priceWas = form.closest('.bbi-buy').querySelector('[data-bbi-price-was]');

    if (!match) {
      if (atc) { atc.disabled = true; atc.dataset.originalText = atc.dataset.originalText || atc.innerHTML; atc.textContent = 'Unavailable'; }
      return;
    }

    if (idInput) idInput.value = match.id;
    if (priceNow) priceNow.innerHTML = match.price;
    if (priceWas) {
      if (match.compare_at && match.compare_at !== match.price) {
        priceWas.innerHTML = match.compare_at;
        priceWas.style.display = '';
      } else {
        priceWas.style.display = 'none';
      }
    }
    if (atc) {
      atc.disabled = !match.available;
      if (!match.available) {
        atc.dataset.originalText = atc.dataset.originalText || atc.innerHTML;
        atc.textContent = 'Sold out';
      } else if (atc.dataset.originalText) {
        atc.innerHTML = atc.dataset.originalText;
      }
    }
  }

  /* ---------- carousel ---------- */
  function railClick(e) {
    var btn = e.target.closest('.bbi-rail__nav button');
    if (!btn) return;
    var wrap = btn.closest('.bbi-revs');
    var rail = wrap && wrap.querySelector('.bbi-rail');
    if (!rail) return;
    var card = rail.querySelector('.bbi-rcard');
    if (!card) return;
    var step = card.getBoundingClientRect().width + 20;
    rail.scrollBy({ left: step * Number(btn.dataset.dir || 1), behavior: 'smooth' });
  }

  /* ---------- size-guide modal ---------- */
  function modalClick(e) {
    var open = e.target.closest('[data-bbi-modal-open]');
    if (open) {
      var target = document.getElementById(open.getAttribute('data-bbi-modal-open'));
      if (target) target.classList.add('is-open');
      return;
    }
    var close = e.target.closest('[data-bbi-modal-close]');
    if (close) {
      var m = close.closest('.bbi-modal');
      if (m) m.classList.remove('is-open');
      return;
    }
    if (e.target.classList && e.target.classList.contains('bbi-modal')) {
      e.target.classList.remove('is-open');
    }
  }

  document.addEventListener('click', function (e) {
    galleryClick(e);
    galleryNav(e);
    railClick(e);
    modalClick(e);
  });

  document.addEventListener('pointerdown', beforeAfterDown);
  document.addEventListener('pointermove', beforeAfterMove, { passive: false });
  document.addEventListener('pointerup', beforeAfterUp);
  document.addEventListener('pointercancel', beforeAfterUp);
  document.addEventListener('input', beforeAfterInput);

  document.addEventListener('change', function (e) {
    var form = e.target.closest('.bbi-form');
    if (form && e.target.matches('.bbi-opt input')) updateVariant(form);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bbi-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    }
  });

  function init() {
    document.querySelectorAll('.bbi-form').forEach(updateVariant);
    syncGalleryNav();
    fillMarquee();
  }

  // Re-measure once logo images have their real dimensions.
  window.addEventListener('load', function () { syncGalleryNav(); fillMarquee(); });
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Theme Editor lifecycle
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
